import { Layers } from '@helpers/layers';
import { Device, from, until } from '@helpers/media';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import styled, { css } from 'styled-components';
const ButtonContainer = styled.div `
  @media ${until(Device.Tablet)} {
    margin-top: 20px;
    margin-bottom: 40px;
  }
`;
const Wrapper = styled.section `
  position: relative;
  margin: 16px 0 40px;

  @media ${from(Device.TabletLarge)} {
    margin: 24px 0 80px;
  }

  ${({ active }) => active &&
    css `
      @media ${until(Device.Tablet)} {
        ${ButtonStyles.Button} {
          position: fixed;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          z-index: ${Layers.AboveContent};
          width: calc(100% - 30px);
        }
      }
    `}
`;
const BreadcrumbWrapper = styled.div `
  display: block;
  margin-bottom: 54px;
  width: 100%;

  @media ${from(Device.TabletLarge)} {
    margin-bottom: 72px;
  }
`;
const ImageContainer = styled.div `
  display: flex;
  justify-content: center;
`;
const Image = styled.img `
  width: 100%;

  @media ${from(Device.DesktopLarge)} {
    max-width: 640px;
  }
`;
const Container = styled.div ``;
const SuperTitleContainer = styled.div ``;
const TitleContainer = styled.div `
  @media ${until(Device.Tablet)} {
    h1 {
      margin-bottom: 7px;
    }
  }
`;
const ContentContainer = styled.div `
  margin-bottom: 32px;

  ${ParagraphStyles.Paragraph} {
    margin-bottom: 0;
  }

  @media ${until(Device.Tablet)} {
    order: 2;
  }
`;
const Content = styled.div ``;
const SubWrapper = styled.div `
  @media ${until(Device.Tablet)} {
    display: flex;
    flex-direction: column-reverse;
  }
`;
const ContentWrapper = styled.div `
  @media ${until(Device.Tablet)} {
    display: grid;
  }
`;
const ImageContainerMobile = styled.div `
  display: none;

  @media ${until(Device.Tablet)} {
    display: block;
  }
`;
const ImageContainerDesktop = styled.div `
  display: block;

  @media ${until(Device.Tablet)} {
    ${({ active }) => active &&
    css `
        display: none;
      `}
  }
`;
export const BrandPageBannerStyles = {
    Wrapper,
    Container,
    SuperTitleContainer,
    TitleContainer,
    ContentContainer,
    Content,
    ImageContainer,
    Image,
    ButtonContainer,
    BreadcrumbWrapper,
    SubWrapper,
    ImageContainerMobile,
    ContentWrapper,
    ImageContainerDesktop,
};
